export default __webpack_public_path__ + "static/media/image0.10d76d3e.png";